import { Route, Routes } from "react-router-dom";
import { Registration } from "./components/Registration";
import { ResetPassword } from "./components/ResetPassword";
import { Login } from "./components/Login";
import { VerifyEmail } from "./components/VerifyEmail";
import { AuthLayout } from "../../layouts/AuthLayout";
import { Notice } from "../common/cards/Notice";

interface AuthPageProps {
  ExistsRedirectPath?: string;
}

const AuthPage = ({ ExistsRedirectPath = "/dashboard" }: AuthPageProps) => (
  <Routes>
    <Route element={<AuthLayout />}>
      <Route path="login" element={
        <Login
          notice={<Notice
            noticeClasses={
              "notice d-flex bg-light-warning rounded border-warning border-dashed p-6"
            }
            button={null}
            header={null}
            content={
              "Get more annuity income by signing in and telling us a few more details."
            }
            icon={null}
            iconClasses={null}
          />}
        />}
      />
      <Route path="registration" element={<Registration />} />
      <Route path="reset-password" element={<ResetPassword />} />
      <Route
        path="verify-email"
        element={<VerifyEmail ExistsRedirectPath={ExistsRedirectPath} />}
      />
      <Route index element={
        <Login notice={
          <Notice
            noticeClasses={
              "notice d-flex bg-light-warning rounded border-warning border-dashed p-6"
            }
            button={null}
            header={null}
            content={
              "Get more annuity income by signing in and telling us a few more details."
            }
            icon={null}
            iconClasses={null}
          />}
        />}
      />
    </Route>
  </Routes>
);

export { AuthPage };
